import Form_Entity from "./form";
export default class Form extends Form_Entity {
  static fromList(formsJSON: unknown): Array<Form> {
    const forms: Form[] = [];
    if (formsJSON)
      Array.isArray(formsJSON) &&
        formsJSON.forEach((formJSON) => {
          forms.push(new Form(formJSON));
        });
    return forms;
  }

  toJson(): string {
    return JSON.stringify(this);
  }
}
